import { toObject, objectToArray } from '../../utils/Converter';
import { Stage, Mission, Skill } from '../../store/missions/types';
import { autoId } from '../../utils/UidGenerator';

const extractMissionData = (data: object) => {
    const mission = new Map<string, Map<string, string>>();
    const skills = new Map<string, Map<string, Map<string, string>>>();
    let publishFrom = null;
    let publishTo = null;
    let image = '';
    let survey = false;
    Object.entries(data).map(([key, value]) => {
        const splitedKey = key.split('_');
        const isSkill = splitedKey.length > 2;
        const field = !isSkill ? splitedKey[0] : splitedKey[1];
        const language = !isSkill ? splitedKey[1] : splitedKey[2];
        const guid = isSkill ? splitedKey[0] : '';
        if (field === 'publishFrom') publishFrom = value;
        if (field === 'publishTo') publishTo = value;
        if (field === 'image' && !isSkill) image = value;
        if (field === 'survey') {
            if (value === 'true') {
                survey = true;
            } else {
                survey = false;
            }
        }
        if (!isSkill && mission.has(field))
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            mission.set(field, mission.get(field)!.set(language, value));
        else if (!isSkill && !mission.has(field)) mission.set(field, new Map().set(language, value));
        else {
            if (skills.has(guid)) {
                if (skills.get(guid)?.has(field)) {
                    const skill = skills.get(guid);
                    const fieldValue = skill?.get(field);
                    if (skill && fieldValue) {
                        fieldValue.set(language, value);
                        skills.set(guid, skill.set(field, fieldValue));
                    }
                } else {
                    const skill = skills.get(guid);
                    if (skill) {
                        skill.set(field, new Map().set(language, value));
                        skills.set(guid, skill);
                    }
                }
            } else skills.set(guid, new Map().set(field, new Map().set(language, value)));
        }
    });
    return {
        mission,
        skills,
        publishFrom: publishFrom,
        publishTo: publishTo,
        image: image,
        isSurveyDifferent: survey,
    };
};

const extractStageData = (data: object) => {
    const stage = new Map<string, Map<string, string>>();
    let image = '';
    Object.entries(data).map(([key, value]) => {
        const splitedKey = key.split('_');
        const field = splitedKey[0];
        const language = splitedKey[1];
        if (field === 'image') image = value;
        if (stage.has(field))
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            stage.set(field, stage.get(field)!.set(language, value));
        else if (!stage.has(field)) stage.set(field, new Map().set(language, value));
    });
    return { stage, image };
};

export const getMissionData = (data: object) => {
    const result = extractMissionData(data);
    return {
        mission: {
            description: toObject(result.mission.get('description')),
            stagesTitle: toObject(result.mission.get('stagesTitle')),
            image: result.image ?? '',
            exercisesTitle: toObject(result.mission.get('exercisesTitle')),
            name: toObject(result.mission.get('name')),
            id: result.mission.get('id')?.get('pl') ?? autoId(),
            publishFrom: result.publishFrom ? new Date(result.publishFrom) : null,
            publishTo: result.publishTo ? new Date(result.publishTo) : null,
            isSurveyDifferent: result.isSurveyDifferent,
        } as Mission,
        skills: objectToArray(toObject(result.skills)).map((item) => {
            const itemRecord = item as Record<string, object>;
            const imageRecord = itemRecord['image'] as Record<string, string>;
            return { ...item, image: imageRecord ? imageRecord['pl'] : '' } as Skill;
        }),
        isNewMission: !result.mission.get('id')?.get('pl'),
    };
};

export const getStageData = (data: object, order?: number) => {
    const result = extractStageData(data);
    const name = result.stage.get('name');
    const description = result.stage.get('description');
    return {
        name: name ? Object.fromEntries(name) : {},
        description: description ? Object.fromEntries(description) : {},
        id: result.stage.get('id')?.get('pl') ?? autoId(),
        image: result.image,
        order: order,
    } as Stage;
};
